<template>
    <div v-if="bookable">
        <!-- <b-btn v-b-modal.application-1 variant="primary" class="btn-block">Anmeldung</b-btn> -->
        <b-btn variant="primary" class="btn-block" @click="showModal">An-/Abmeldung</b-btn>

        <b-modal id="application-1" centered title="BootstrapVue" @ok="save()" :no-close-on-esc="true">
            <div v-for="(a, i) in agenda" :key="i" :class="i < agenda.length - 1 ? '' : 'mt-4'">
                <span class="datetime text-primary"><strong class="">{{ a.agenda_date | format_date }}</strong> ab {{ a.agenda_begin }} Uhr</span>
                <strong class="introtext d-block" v-html="nl2br(a.agenda_title)"></strong>
                <b-form-select
                    :id="`agenda_register_self_${a.agenda_hash}`"
                    :name="`agenda_register_self_${a.agenda_hash}`"
                    data-type="register_self"
                    @change="registerSelf(a.agenda_hash, $event), togglePartnerGuestOptions(a.agenda_hash)"
                    :options="agenda_register_self_options"
                    style="margin: 10px 0"
                ></b-form-select>
                
                <!-- <div class="form-control">
                    <b-form-checkbox
                        :id="`agenda_register_self_${a.agenda_hash}`"
                        :name="`agenda_register_self_${a.agenda_hash}`"
                        data-type="register_self"
                        value=true
                        unchecked-value=false
                        class=""
                        @change="registerSelf(a.agenda_hash, $event), togglePartnerGuestOptions(a.agenda_hash)"
                        switch>
                        Ich komme 
                    </b-form-checkbox>
                </div> -->

                <div class="form-control d-none">
                    <b-form-checkbox
                        :id="`agenda_register_partner_${a.agenda_hash}`"
                        :name="`agenda_register_partner_${a.agenda_hash}`"

                        value=0
                        unchecked-value=2
                        switch
                        @change="registerPartner(a.agenda_hash, $event)"
                        v-if="a.agenda_user_spouse_bool">
                        Ich bringe meinen Partner mit 
                    </b-form-checkbox>
                </div>

                <b-row v-if="a.agenda_user_guests_bool"> 
                    <b-col cols="8">

                        <div class="form-control d-none">
                            <b-form-checkbox
                                :id="`agenda_register_guests_${a.agenda_hash}`"
                                :name="`agenda_register_guests_${a.agenda_hash}`"

                                :value="a.agenda_hash"
                                unchecked-value=false
                                @change="toggleGuestOptions(a.agenda_hash), registerGuest(a.agenda_hash, $event)"
                                switch>
                                Ich komme mit Gästen
                            </b-form-checkbox>
                        </div>
                    </b-col>
                    <b-col>
                        <!-- <div class="form-control"> -->
                            <select 
                                :id="`agenda_guests_dropdown_${a.agenda_hash}`"
                                :name="`agenda_guests_dropdown_${a.agenda_hash}`"
                                class="d-none form-control"
                                @change="updateGuests(a.agenda_hash, $event)"
                                >
                                <option v-for="(so, so_i) in select_guest_options" :key="so_i" :value="so.value">{{ so.text }}</option>
                            </select>
                        <!-- </div> -->
                    </b-col>
                </b-row>
            </div>
            <template v-if="!fetching" v-slot:modal-footer="{ ok, cancel, hide }" class="pt-0">
                <!-- Emulate built in modal footer ok and cancel button actions -->
                <b-button variant="primary" class="btn-block d-none" @click="ok()" id="submit_button">
                    <strong>Speichern und schließen</strong>
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
export default {
    name: 'application',
    components: {

    },
    props: {
        agenda: {
        },
        max_guest_count: {
            type: Number,
            default: 10
        },
        event_id: {
            type: Number
        }
    },
    created() {
    },
    mounted() {
        this.$root.$off('bv::modal::shown').$on('bv::modal::shown', () => {
            this.handleShown();
        });
        // this.fetchAgendaData();
    },
    computed: {
        ...mapGetters('events', [
            'fetching'
        ]),
        ...mapGetters('auth', ['getUserId']),

        bookable() {
            const test = this.agenda.find((a) => {
                const agenda_date = moment(a.agenda_date);
                const default_rspv = agenda_date.subtract(4, 'days');
                const current = moment();
                if (a.agenda_rsvp_date) {
                    return current.isSameOrBefore(moment(a.agenda_rsvp_date));
                } else {
                    return current.isSameOrBefore(default_rspv);
                }
            });
            return test;
        },

        select_guest_options() {
            const data = [];
            for (let index = 1; index <= this.max_guest_count; index++) {
                const text = index > 1 ? 'Gäste' : 'Gast';
                data.push({value: index, text: `${index} ${text}`});
            }
            return data;
        },
    },
    data() {
        return {
            registers: [],
            pre_filled: [],
            self_register: [

            ],
            agenda_register_self_options: [
                {
                    value: -1, text: 'Bitte wählen'
                },
                {
                    value: 0, text: 'Ich komme'
                },
                {
                    value: 2, text: 'Ich komme nicht'
                }
            ]
        }
    },
    methods: {
        ...mapActions('events', ['saveApplication', 'fetchEvent']),
        nl2br(string) {
            return string.replace(/(?:\r\n|\r|\n)/g, '<br />');
        },
        fetchAgendaData() {
            // console.log(this.agenda);
            this.agenda.forEach(a => {
                const hash = a.agenda_hash;
                const agenda_registered_attendees = Object.values(a.agenda_registered_attendee);
                let count_guests = 0;
                document.querySelector(`#agenda_register_self_${hash}`).value = -1;
                // console.log(agenda_registered_attendees[1], this.getUserId);


                agenda_registered_attendees.forEach(agenda_registered_attendee => {
                    const attendee_status = typeof agenda_registered_attendee.attendee_status === 'undefined' ? agenda_registered_attendee.status : agenda_registered_attendee.attendee_status; 
                    const attendee_user = typeof agenda_registered_attendee.attendee_user === 'undefined' ? agenda_registered_attendee.ID : agenda_registered_attendee.attendee_user; 
                    // console.log(attendee_status);
                    // eingeloggter nutzer ist am event gespeichert
                    // this.self_register[hash] = attendee_status;
                    // console.log(attendee_status, this.self_register)
                    if (agenda_registered_attendee && attendee_status != 2 && attendee_user == this.getUserId) {
                        document.querySelector(`#agenda_register_self_${hash}`).value = attendee_status;
                        this.registerSelf(hash, attendee_status)
                        this.togglePartnerGuestOptions(hash);

                        // if (!document.querySelector(`#agenda_register_self_${hash}`).classList.contains('clicked')) {
                        //     document.querySelector(`#agenda_register_self_${hash}`).classList.add('clicked')
                        //     document.querySelector(`#agenda_register_self_${hash}`).click();
                        // }
                        
                        if (agenda_registered_attendee.attendee_type == 'spouse' || (agenda_registered_attendee.spouse && agenda_registered_attendee.spouse.status === "0")) { //  0 (integer) = noch nicht gesetzt | "0" (string) durch user gesetzt, aber noch nicht bestätigt
                            if (!document.querySelector(`#agenda_register_partner_${hash}`).classList.contains('clicked')) {
                                document.querySelector(`#agenda_register_partner_${hash}`).classList.add('clicked')
                                document.querySelector(`#agenda_register_partner_${hash}`).click();
                            }
                        }

                        if (agenda_registered_attendee.count_guest) {
                            if (!document.querySelector(`#agenda_register_guests_${hash}`).classList.contains('clicked')) {
                                document.querySelector(`#agenda_register_guests_${hash}`).classList.add('clicked')
                                document.querySelector(`#agenda_register_guests_${hash}`).click();
                                // document.querySelector(`#agenda_guests_dropdown_${hash}`).value = 0;
                            }
                            document.querySelector(`#agenda_guests_dropdown_${hash}`).value = agenda_registered_attendee.count_guest;
                            this.updateGuests(hash, false, agenda_registered_attendee.count_guest);
                            
                        } else {
                            if (agenda_registered_attendee.attendee_type == 'guest') {
                                count_guests++;
                                if (!document.querySelector(`#agenda_register_guests_${hash}`).classList.contains('clicked')) {
                                    document.querySelector(`#agenda_register_guests_${hash}`).classList.add('clicked')
                                    document.querySelector(`#agenda_register_guests_${hash}`).click();
                                    // document.querySelector(`#agenda_guests_dropdown_${hash}`).value = 0;
                                }
                                document.querySelector(`#agenda_guests_dropdown_${hash}`).value = count_guests;
                                this.updateGuests(hash, false, count_guests);
                            }
                        }
    

                        // console.log(agenda_registered_attendee);
                    }
                    if (attendee_status == 2) {
                        document.querySelector(`#agenda_register_self_${hash}`).value = attendee_status
                    }
                });
                // this.pre_filled.push()
            })
            this.showSubmitButton();
        },
        showModal() {
            this.$root.$emit('bv::show::modal', 'application-1')
        },
        handleShown() {
            // alert('shown');
            this.fetchAgendaData();
            // document.querySelector(`#agenda_register_self_0931B-02548`).click();
        },
        save() {
            this.saveApplication({event_id: this.event_id,application_data: this.registers});
        },
        hashExists(hash) {
            // const BreakException = {};
            return this.registers.find(x => x.hash == hash);
            // try {
            //     this.registers.forEach(el => {
            //         if (el.hash == hash) {
            //             throw BreakException;
            //         }
            //     });
            //     return false
            // } catch (e) {
            //     return true;
            // }
        },
        updateRegisters(hash, data) {
            this.registers.forEach((el, i) => {
                if (el.hash == hash) {
                    const registered_obj = this.registers[i];
                    this.registers[i] = {...registered_obj, ...data};
                }
            });
        },
        registerSelf(hash, checked) {
            console.log('register_self', checked)
            const obj = {
                hash: hash,
                register_self: (checked == 0),
            };
            // console.log(obj)
            if (!this.hashExists(hash)) {
                this.registers.push(obj);
            } else {
                this.updateRegisters(hash, obj);
            }
            if (!obj.register_self) {
                this.registerPartner(hash, checked);
                this.registerGuest(hash, checked);
            }
            this.showSubmitButton();
        },
        registerPartner(hash, checked) {
            const register_partner = checked == 2 || checked == 0 ? checked == 0 : checked;
            // console.log('register partner', register_partner)
            const obj = {
                hash: hash,
                register_partner: (register_partner),
            };
            if (!this.hashExists(hash)) {
                this.registers.push(obj);
            } else {
                this.updateRegisters(hash, obj);
            }
        },
        registerGuest(hash, checked) {
            const obj = {
                hash: hash,
                register_guests: checked == 0 ? 1 : 0,
            };
            if (!this.hashExists(hash)) {
                this.registers.push(obj);
            } else {
                this.updateRegisters(hash, obj);
            }
        },
        updateGuests(hash, el, manual_value = false){
            // console.log(hash, manual_value);
            const count_guests = !manual_value ? parseInt(el.srcElement.value) : manual_value;
            const obj = {
                hash: hash,
                register_guests: count_guests,
            };
            if (!this.hashExists(hash)) {
                this.registers.push(obj);
            } else {
                this.updateRegisters(hash, obj);
            }
        },
        togglePartnerGuestOptions(agenda_hash) {
            // const self_checkbox = document.querySelector(`#agenda_register_self_${agenda_hash}`);
            const self_dropdown = document.querySelector(`#agenda_register_self_${agenda_hash}`).value;
            const partner_checkbox = document.querySelector(`#agenda_register_partner_${agenda_hash}`);
            const partner_wrapper = partner_checkbox ? partner_checkbox.closest('.form-control') : false;
            const guest_checkbox = document.querySelector(`#agenda_register_guests_${agenda_hash}`);
            const guest_wrapper = guest_checkbox ? guest_checkbox.closest('.form-control') : false;
            if (self_dropdown == 0) {
                if (partner_wrapper) {
                    partner_wrapper.classList.remove('d-none');
                }
                if (guest_wrapper) {
                    guest_wrapper.classList.remove('d-none');
                }
            } else  {
                if (partner_wrapper) {
                    partner_wrapper.classList.add('d-none');
                }
                if (guest_wrapper) {
                    guest_wrapper.classList.add('d-none');
                }
            }
        },
        toggleGuestOptions(agenda_hash) {
            const guest_checkbox = document.querySelector(`#agenda_register_guests_${agenda_hash}`);
            const guest_dropdown = document.querySelector(`#agenda_guests_dropdown_${agenda_hash}`);

            if (guest_checkbox.checked) {
                guest_dropdown.classList.remove('d-none');
            } else  {
                guest_dropdown.classList.add('d-none');
            }
        },
        showSubmitButton() {
            const notSelfSelected = this.agenda.filter((a) => {
                const self_dropdown = document.querySelector(`#agenda_register_self_${a.agenda_hash}`);
                // console.log(self_dropdown.value)
                return self_dropdown.value < 0;
            });
            if (notSelfSelected.length != 0) {
                document.querySelector('#submit_button').classList.add('d-none');
            } else {
                document.querySelector('#submit_button').classList.remove('d-none')
            }
        },
    }
}
</script>

<style lang="scss">
.modal {
    header {
        display: none;
    }

    footer {
        border-top: 0;
    }

    .datetime {
        font-size: 20px;
        text-transform: uppercase;
        line-height: 22px;
    }

    .modal-body {
        padding-bottom: 0;
    }

    .modal-footer {
        padding-top: 0;
    }

    .introtext {
        font-size: 14px;
    }

    .form-control {
        margin: 10px 0;
    }

    .custom-control {
        padding-left: 50px;
    }

    .custom-switch .custom-control-label::before {
        left: -50px;
        width: 40px;
        border-radius: 24px;
        top: -5px;
    }

    .custom-switch .custom-control-label::after {
        width: 22px;
        height: 22px;
        border-radius: 12px;
        left: -49px;
        top: -4px;
    }

    .custom-control-label::before {
        height: 24px;
    }

    .custom-control-input:checked ~ .custom-control-label::before {
        left: -50px;
        width: 40px;
        top: -5px;
    }
    
    .custom-control-input:checked ~ .custom-control-label::after {
        width: 22px;
        height: 22px;
    }

    .custom-switch .custom-control-input:checked ~ .custom-control-label::after {
        transform: translateX(16px);
    }
}
</style>